import { useEffect, useState } from "react";
import api from "@/lib/api";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import MarqueeStrip from "@/components/site/MarqueeStrip";
import Manifesto from "@/components/site/Manifesto";
import Services from "@/components/site/Services";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import ContactCTA from "@/components/site/ContactCTA";
import Footer from "@/components/site/Footer";
import SmoothScroll from "@/components/SmoothScroll";

const DEFAULT_CONTENT = {
    hero_eyebrow: "Greenwell Springs · Baton Rouge, LA",
    hero_title_1: "We Build",
    hero_title_2: "Your Vision",
    hero_subtitle:
        "House renovation, concrete, flooring & painting — from a Greenwell Springs crew that treats your home as we would our own. Licensed & Insured. Free estimates.",
    logo_url:
        "https://customer-assets-jai6qajn.emergentagent.net/job_b22c5b56-04fb-4280-a656-718926939417/artifacts/vxy3ybj0_224078.jpg",
    phone: "+1 (225) 620-2635",
    phone_raw: "+12256202635",
    whatsapp: "12256202635",
    email: "arieldias199816@icloud.com",
    service_area: "Greenwell Springs · Baton Rouge · Denham Springs · Central · Zachary · Prairieville",
    about_paragraph:
        "Home Renovation | Steven R. Construction LLC is a Greenwell Springs / Baton Rouge team handling everything from concrete to flooring to painting. We treat your home like we would our own.",
    hours: "Mon – Sat · 7:00 AM – 6:00 PM",
};

export default function LandingPage() {
    const [content, setContent] = useState(DEFAULT_CONTENT);
    const [gallery, setGallery] = useState([]);
    const [testimonials, setTestimonials] = useState([]);

    useEffect(() => {
        const load = async () => {
            try {
                const [c, g, t] = await Promise.all([
                    api.get("/content"),
                    api.get("/gallery"),
                    api.get("/testimonials"),
                ]);
                setContent({ ...DEFAULT_CONTENT, ...c.data });
                setGallery(g.data || []);
                setTestimonials(t.data || []);
            } catch (_e) {
                // fall through with defaults
            }
        };
        load();
    }, []);

    return (
        <SmoothScroll>
            <div className="relative bg-[color:var(--bg-primary)]">
                <Nav content={content} />
                <Hero content={content} />
                <MarqueeStrip />
                <Manifesto content={content} />
                <Services />
                <Gallery items={gallery} />
                <Testimonials items={testimonials} />
                <ContactCTA content={content} />
                <Footer content={content} />
            </div>
        </SmoothScroll>
    );
}
